export const REGIONS = [
  { value: 'BR', label: 'Brasil' },
  { value: 'S', label: 'Sul' },
  { value: 'SE', label: 'Sudeste' },
  { value: 'CO', label: 'Centro-Oeste' },
  { value: 'NE', label: 'Nordeste' },
  { value: 'N', label: 'Norte' },
];

export const PERIODS = [
  { value: 'd+0', label: 'Diário' },
  { value: 'p+0', label: 'Pentada' },
  { value: 's+0', label: 'Semanal' },
  { value: 'm+0', label: 'Mensal' },
];
